import axios from "utils/axios"
import * as APITypes from "constants/API"

const salutationMaster = async () => {
 const response = await axios.get(APITypes.SALUTATION_MASTER)
 return response.data
}


export default salutationMaster